import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Sanitized & sealed",
    copy: "Every tote is washed, sanitized and inspected between rentals. Lids latch, hinges hold, no mystery smells. If it wouldn't carry our own kitchen, it doesn't ship.",
  },
  {
    n: "02",
    title: "Delivered & picked up",
    copy: "We drop your package off before moving day and collect it once you're unpacked. No cardboard runs, no tape battles, no dumpster trips.",
  },
  {
    n: "03",
    title: "Zero-waste moving",
    copy: "One tote replaces up to 60 cardboard boxes over its working life. Easier on the Cascades, easier on your wallet, and impossible to give you a soggy bottom.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-royal">
          Why Oregon Tote Rentals
        </p>
        <h2 className="mt-4 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Moving day, minus the dumpster.
        </h2>
      </Reveal>
      <div className="mt-16 space-y-0">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1}>
            <div className="grid gap-6 border-t border-slate-200 py-12 transition-colors duration-300 hover:bg-royal-light/40 lg:grid-cols-12 lg:gap-10 lg:px-6">
              <p className="font-mono text-5xl font-semibold text-royal/25 lg:col-span-2 lg:text-6xl">
                {c.n}
              </p>
              <h3 className="font-display text-xl font-bold tracking-tight text-ink sm:text-2xl lg:col-span-4">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-slate-600 lg:col-span-6">
                {c.copy}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
